import { extendComponent } from "@eusoft/webapp-core/Component";
import { ObjectEditor, required, staticItemsSource, type IObjectEditorOptions} from "@eusoft/webapp-ui";
import type { IAddressData } from "../entities/Commands";
import "./AddressEditor.scss"


export const AddressEditor = extendComponent(ObjectEditor<IAddressData>, { }, {
    style: ["vertical"],
    name: "address-editor",
    commitMode: "manual",
    validationMode: "manual",
    inputField: {
        style: "filled" 
    },
    builder: bld => <>
        {bld.text(m => m.streetName, {
            validators: [required]

        })}
        {bld.text(m => m.postalCode, {
            validators: [required]
        })}
        {bld.text(m => m.city, {
            validators: [required]
        })}
        {bld.singleSelector(m => m.countryCode, {
            label: "country",
            validators: [required],
            editor: {
                itemsSource: staticItemsSource(["italy", "IT"])
            }
        })}
    </>
} as IObjectEditorOptions<IAddressData>);
